import { action, observable } from 'mobx'
import { ModalViewModel } from '@/infra/ModalViewModel'

export interface UserInfoItemListProps {
  title: string
  userInfoItems: string[]
}

export class UserInfoItemListDialogViewModel {
  readonly modal = new ModalViewModel()

  /**
   * Title to use for the dialog.
   */
  @observable
  accessor title = ''

  /**
   * List of user info items.
   */
  @observable
  accessor userInfoItems: string[] = []

  /**
   * Sets the title.
   */
  @action.bound
  setTitle(title: string) {
    this.title = title
  }

  /**
   * Sets the user info items.
   */
  @action.bound
  setUserInfoItems(userInfoItems: string[]) {
    this.userInfoItems = userInfoItems
  }

  /**
   * Opens the dialog.
   */
  @action.bound
  showWith(props: UserInfoItemListProps) {
    this.setTitle(props.title)
    this.setUserInfoItems(props.userInfoItems)
    this.modal.show()
  }

  /**
   * Closes the dialog.
   */
  @action.bound
  close() {
    this.modal.close()
    this.reset()
  }

  /**
   * Resets the dialog.
   */
  @action.bound
  reset() {
    this.title = ''
    this.userInfoItems = []
  }

  normalizeString(text: string) {
    return text.toLowerCase().replace(/\s+/g, '-')
  }
}
